module.exports = __webpack_public_path__ + "static/media/ClassPhoto.863eb056.svg";